import { Injectable } from "@angular/core";

@Injectable()
export class AgroConfigBackEnd {

  private URI_BACKEND: string;
  private URI_TAUTH: string;

  constructor() {

    this._carregarConfiguracao(json => {
      this.URI_BACKEND = json.url;
      this.URI_TAUTH = json.urlTauth;
    });
  }

  public getBackEnd(): string {
    return this.URI_BACKEND;
  };

  public getTauth(): string {
    return this.URI_TAUTH ? this.URI_TAUTH : this.URI_BACKEND;
  };

  private _carregarConfiguracao(callBack: (json: any) => void) {

    let fileConfiguration = window.location.origin;

    if (window.location.pathname.split('/')[1]) {

      if (window.location.pathname.split('/')[1] === 'modules' && window.location.pathname.split('/').length > 3) {
        fileConfiguration = fileConfiguration + '/' + window.location.pathname.split('/')[1] + '/' + window.location.pathname.split('/')[2]
      } else if (window.location.pathname.split('/')[1] === 'pims-web') {
        fileConfiguration = fileConfiguration + '/' + window.location.pathname.split('/')[1]
      }

    }

    fileConfiguration = fileConfiguration + '/config/agro.json';

    var raw = new XMLHttpRequest();
    raw.open("GET", fileConfiguration, false);
    raw.onreadystatechange = function () {
      if (raw.readyState === 4) {
        if (raw.status === 200 || raw.status == 0) {
          var response = JSON.parse(raw.responseText);
          callBack(response);
        }
      }
    }
    raw.send(null);
  }
}